import React from 'react';
import { useRouter } from 'next/router';
import { Dialog, Button, Stack, Typography } from '@krakentech/coral';
import { IconGift } from '@krakentech/icons';

type RewardDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const RewardDialog = ({ isOpen, onClose }: RewardDialogProps) => {
  const { push } = useRouter();

  const handleNoThanks = () => {
    onClose();
  };

  const handleClaimReward = () => {
    onClose();
    push('/rewards'); // TODO: Add reward page internal path
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      ariaLabelledBy="reward-dialog"
      maxWidth="sm"
    >
      <Stack direction="vertical" gap="md">
        <Stack direction="vertical" gap="sm" alignItems="center">
          <IconGift size={60} />
          <Stack direction="vertical" gap="xxs">
            <Typography textAlign="center" variant="h2">
              You&apos;ve earned a reward!
            </Typography>
            <Typography textAlign="center">
              You&apos;ve unlocked a reward - want to find out what it is?
            </Typography>
          </Stack>
        </Stack>
        <Stack gap="md">
          <Button variant="outlined" onClick={handleNoThanks} fullWidth>
            No thanks
          </Button>
          <Button onClick={handleClaimReward} fullWidth>
            Claim reward
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default RewardDialog;
